<script>
import anime from "animejs";
var ProgressBar = require("progressbar.js");

export default {
    name: "standards-count",
    data() {
        return {
            tweenedNumber: 0,
            progress: null
        };
    },
    methods: {},
    watch: {
        standardsCount(newVal, oldVal) {
            let valueObject = {
                val: oldVal
            };
            anime({
                targets: valueObject,
                val: newVal,
                easing: "linear",
                round: 1,
                update: () => {
                    this.tweenedNumber = valueObject.val;
                }
            });
        },
        hasStandards(exist) {
            if (exist) {
                this.progress.destroy();
            }
        }
    },
    computed: {
        visibleStandards() {
            return this.filteredStandards.length
                ? this.filteredStandards
                : this.standards;
        },
        filteredStandards() {
            return this.$store.getters.filteredStandards;
        },
        standardsCount() {
            return this.$store.getters.standardsCount;
        },
        hasStandards() {
            return this.$store.getters.hasStandards;
        },
        standardsSearchTerm() {
            return this.$store.getters.standardsSearchTerm;
        },
        title() {
            if (this.standardsSearchTerm.length > 2) {
                return `Filtered Standards using search term: <strong>“${
                    this.standardsSearchTerm
                }”</strong>`;
            } else {
                return "All Standards";
            }
        }
    },
    mounted() {
        this.progress = new ProgressBar.Line("#progress", {
            easing: "easeInOut",
            duration: 1800,
            strokeWidth: 0.2,
            color: "#b0a288"
        });
        this.progress.animate(1);
    }
};
</script>

<template>
    <div>
        <h3 v-html="title"></h3>
        <p>
            <strong
                v-if="hasStandards"
            >{{ tweenedNumber }} result{{ standardsCount == 1 ? '' : 's'}}</strong>
            <span v-else>Loading Standards...</span>
        </p>
        <div id="progress"></div>
    </div>
</template>

